"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchFilter = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
//@ts-ignore                
let rwsTemplate = T.html `<template>
    <div class="search-filter-container">
        <div class="search-control">
            <input type="text" :placeholder="${'search.placeholder'.t()}" :value="${x => x.searchQuery}"
                @keyup="${(x, c) => x.onKeyPress(c.event)}" class="form-control">
        </div>
        <div class="search-buttons">
            <button class="btn btn-sm btn-primary" @click="${x => x.searchSubmit()}" :disabled="${x => x.loading}">
                <i class="simple-icon-magnifier"></i>
            </button>
            ${(0, fast_element_1.when)(x => x.searchQuery, (0, fast_element_1.html) `
            <button class="btn btn-sm btn-danger" @click="${x => x.clearSearch()}" title="${'search.clear'.t()}">
                <i class="simple-icon-close"></i>
            </button>
            `)}
        </div>
    </div>
</template>`;
require("./styles/layout.scss");
const styles = T.css `.search-filter-container {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
}
.search-filter-container .search-control input {
  background: none;
  outline: initial !important;
  border: 1px solid #8f8f8f;
  border-radius: 15px;
  padding: 0.25rem 0.75rem;
  font-size: 0.76rem;
  line-height: 1.3;
  color: #3a3a3a;
}`;
const shadowOptions = { "mode": "open" };
let SearchFilter = class SearchFilter extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.placeholder = 'Search...';
        this.queryUrl = '';
        this.queryParam = 'q';
        this.indexUrl = '';
        this.searchQuery = '';
        this.loading = false;
    }
    connectedCallback() {
        super.connectedCallback();
    }
    searchSubmit() {
        // Emit search submit event
        this.$emit('search-submit', { query: this.searchQuery });
    }
    onKeyPress(event) {
        const target = event.target;
        this.searchQuery = target.value;
        this.searchSubmit();
    }
    clearSearch() {
        this.searchQuery = '';
        this.searchSubmit();
    }
};
exports.SearchFilter = SearchFilter;
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], SearchFilter.prototype, "placeholder", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], SearchFilter.prototype, "queryUrl", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], SearchFilter.prototype, "queryParam", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], SearchFilter.prototype, "indexUrl", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], SearchFilter.prototype, "searchQuery", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], SearchFilter.prototype, "loading", void 0);
exports.SearchFilter = SearchFilter = __decorate([
    (0, client_1.RWSView)('search-filter', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], SearchFilter);
SearchFilter.defineComponent();
